import React, { useState, useMemo } from 'react';
import CalcShell, { StepsPanel } from '../CalcShell';
import { CalcNetPanel, Row, UnitInput, ResultTable } from '../_fitnessHelpers';
import { CycleCalendar, FullPregnancyTable } from './_pregnancyHelpers';

const fmt = d => d.toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });

export default function OvulationCalc() {
  const today = new Date().toISOString().slice(0,10);
  const [lmp, setLmp] = useState(today);
  const [cycle, setCycle] = useState(28);
  const clear = () => { setLmp(today); setCycle(28); };

  const c = useMemo(() => {
    const s = new Date(lmp); if (isNaN(s)) return null;
    const ov = new Date(s.getTime() + (cycle - 14) * 86400000);
    const fertileStart = new Date(ov.getTime() - 5 * 86400000);
    const fertileEnd = new Date(ov.getTime() + 1 * 86400000);
    const nextP = new Date(s.getTime() + cycle * 86400000);
    const dueDate = new Date(ov.getTime() + 266 * 86400000);
    return { ov, fertileStart, fertileEnd, nextP, dueDate };
  }, [lmp, cycle]);

  return (
    <CalcShell look="cnet" title="Ovulation Calculator" subtitle='Estimate the ovulation day and fertile window for a menstrual cycle.'>
      <CalcNetPanel
        slug="ov"
        tabs={['Ovulation']}
        activeTab={0}
        onTabChange={() => {}}
        onClear={clear}
        right={c && (
          <div>
            <div className="text-lg text-slate-800">Your estimated ovulation date</div>
            <div className="text-xl font-bold text-[#2f9c3f]" data-testid="ov-date">{fmt(c.ov)}</div>
            <ResultTable
              testid="ov-detail-table"
              rows={[
                ['Fertile window', `${fmt(c.fertileStart)} — ${fmt(c.fertileEnd)}`],
                ['Next expected period', fmt(c.nextP)],
                ['If conception occurs — due date', fmt(c.dueDate)],
              ]}
            />
          </div>
        )}
      >
        <Row label="First day of your last period">
          <input type="date" value={lmp} onChange={e => setLmp(e.target.value)} data-testid="ov-lmp"
            className="flex-1 px-3 py-2 bg-white border border-slate-400 rounded-sm text-sm" />
        </Row>
        <Row label="Average cycle length"><UnitInput value={cycle} onChange={setCycle} unit="days" testid="ov-cycle" /><span className="text-xs text-slate-500 whitespace-nowrap">21 – 45</span></Row>
      </CalcNetPanel>

      <StepsPanel steps={[
        `Ovulation ≈ LMP + (cycle − 14) days`,
        `Fertile window ≈ ovulation − 5 days → ovulation + 1 day`,
      ]} />
      {c && <CycleCalendar lmpDate={new Date(lmp)} cycleLen={cycle} testId="ov-calendar" />}
      {c && <FullPregnancyTable dueDate={c.dueDate} currentWeek={0} testId="ov-full-table" />}
    </CalcShell>
  );
}
